module.exports = __webpack_public_path__ + "img/bodo-glimt-logo-icon.8e67e110.png";